var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { CheckboxStructure } from '../components/CheckboxStructure';
// Styles
import { getCheckboxWithLabelStylesByVariant } from './getCheckboxWithLabelStylesByVariant';
// Utils
import styled from 'styled-components';
export var StyledCheckboxWithLabel = styled(CheckboxStructure)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: min-content 1fr;\n  cursor: default;\n  grid-column-gap: 8px;\n\n  input {\n    opacity: 0;\n    height: 0;\n    width: 0;\n    margin: 0;\n    grid-column: 1 / -1;\n  }\n\n  ", ";\n"], ["\n  display: grid;\n  grid-template-columns: min-content 1fr;\n  cursor: default;\n  grid-column-gap: 8px;\n\n  input {\n    opacity: 0;\n    height: 0;\n    width: 0;\n    margin: 0;\n    grid-column: 1 / -1;\n  }\n\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return getCheckboxWithLabelStylesByVariant(theme);
});
var templateObject_1;
//# sourceMappingURL=StyledCheckboxWithLabel.js.map